// src/components/ChestWall.js
import React from 'react';
import styled from '@emotion/styled';

const ChestWallContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ContentBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 20px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C5C5C6;
  border-radius: 12px;
`;

const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;
  cursor: pointer;
  width: calc(50% - 8px);
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
`;

const ChestWall = ({ data, onChange }) => {
  const handleChange = (condition) => {
    onChange({
      ...data,
      [condition]: !data[condition]
    });
  };

  const conditions = [
    { key: 'Kyphosis', label: 'Kyphosis' },
    { key: 'Scoliosis', label: 'Scoliosis' },
    { key: 'Pectus_Excavatum', label: 'Pectus Excavatum' },
    { key: 'Pectus_Carinatum', label: 'Pectus Carinatum' },
    { key: 'Surgery_Sternotomy', label: 'Surgery Sternotomy' },
    { key: 'Surgery_L_Thoracotomy', label: 'Surgery L Thoracotomy' },
    { key: 'Surgery_R_Thoracotomy', label: 'Surgery R Thoracotomy' }
  ];

  return (
    <ChestWallContainer>
      <ContentBox>
        <CheckboxGroup>
          {conditions.map(({ key, label }) => (
            <CheckboxLabel key={key}>
              <Checkbox
                type="checkbox"
                checked={data[key]}
                onChange={() => handleChange(key)}
              />
              {label}
            </CheckboxLabel>
          ))}
        </CheckboxGroup>
      </ContentBox>
    </ChestWallContainer>
  );
};

export default ChestWall;
